import React from 'react';
import { Link } from 'react-router-dom';
import './AutoStorePage.css';

const ThankYouPage = () => (
  <main className="auto-store-main">
    <section className="auto-store-hero">
      <h1>Thank You!</h1>
      <p>Your order has been placed successfully.</p>
      <Link to="/auto-store" className="auto-add-btn" style={{marginTop: 24}}>Back to Store</Link>
    </section>
  </main>
);

export default ThankYouPage; 